import { useTranslation } from "react-i18next";
import { Icon, Modal } from "@repo/ui";

import "./inappropriateImageModal.css";

export type ImageIssueVariant = "inappropriate" | "unreadable";

const VARIANT_MESSAGE_KEY: Record<ImageIssueVariant, string> = {
  inappropriate: "inappropriate_image_message",
  unreadable: "unreadable_image_message",
};

type Props = {
  isOpen: boolean;
  onReupload: () => void;
  overlayZIndex?: number;
  variant?: ImageIssueVariant;
};

export function InappropriateImageModal({
  isOpen,
  onReupload,
  overlayZIndex = 2100,
  variant = "inappropriate",
}: Props) {
  const { t } = useTranslation("doubts");

  const body = (
    <div className="inappropriate-image-modal__body">
      <div className="inappropriate-image-modal__content">
        <Icon name="alert" width={80} height={80} />
        <p className="inappropriate-image-modal__message">
          {t(VARIANT_MESSAGE_KEY[variant])}
        </p>
      </div>
      <button
        type="button"
        className="inappropriate-image-modal__cta"
        onClick={onReupload}
      >
        {t("re_upload")}
      </button>
    </div>
  );

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={onReupload}
      showFooter={false}
      showHeader={false}
      width="min(26.75rem, 92vw)"
      height="auto"
      body={body}
      alignItems="center"
      modalClassName="inappropriate-image-modal__card"
      bodyClassName="inappropriate-image-modal__body-wrap"
      styles={{
        overlay: { zIndex: overlayZIndex },
        modal: {
          borderRadius: "1.5rem",
          overflow: "hidden",
        },
        body: {
          padding: 0,
          overflow: "visible",
        },
      }}
    />
  );
}
